export default __webpack_public_path__ + "static/tooltip-truncation-do-dark-62834f431b08d91830c1fdb3f4e0ffaf.png";